import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './Pages/Home';
import DownloadPage from './Pages/Download';
import SignInPage from './Pages/SignInPage';
import SignUpPage from './Pages/SignUpPage';
import PrivacyPolicy from './Pages/PrivacyPolicy';
import CookiePolicy from './Pages/CookiePolicy';
import TermsofService from './Pages/TermsOfService';
import { UserProvider } from './Contexts/UserContext';
import Profile from './Pages/Profile';
import ScrollToTop from './Components/ScrolltoTop';
import CookieConsent from './Components/CookieConsent';
import EndUserLicenseAgreement from './Pages/Eula';

function App() {
  return (
    <UserProvider>
      <CookieConsent>
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/download" element={<DownloadPage />} />
        <Route path="/signin" element={<SignInPage />} />
        <Route path="/signup" element={<SignUpPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
        <Route path="/terms-of-service" element={<TermsofService />} /> 
        <Route path="/profile" element={<Profile />} />
        <Route path="/eula" element={<EndUserLicenseAgreement />} /> 
      </Routes>
    </Router>
    </CookieConsent>
    </UserProvider>
  );
}

export default App;
